export default __webpack_public_path__ + "static/media/pag404-Nearshorit_icone.1a88e62e.svg";